import * as React from "react";

const { Component } = React;

import { alert } from "../general/alertStore";
import { Integration } from "./Integrations";

import * as PermissionStore from "../identityPermissions/IdentityPermissionStore";

import axios from "../general/HttpClient";

interface IntegrationTriggerProps {
    integration: Integration;
}

interface IntegrationTriggerState {
    integration: Integration;
}

export default class IntegrationTrigger extends Component<IntegrationTriggerProps, IntegrationTriggerState> {
    constructor(props) {
        super(props);
        this.state = {
            integration: props.integration,
        };
    }

    static getDerivedStateFromProps = (nextProps) => {
        if (nextProps.integration) {
            return { integration: nextProps.integration };
        }
    };

    componentDidMount() {}

    enableTrigger = () => {
        axios.post(`/api/Integrations/${this.state.integration.integrationId}/Trigger`, {}).then((response) => {
            this.setState({ integration: response.data });
        });
    };

    disableTrigger = () => {
        axios.delete(`/api/Integrations/${this.state.integration.integrationId}/Trigger`).then((response) => {
            this.setState({ integration: response.data });
        });
    };

    testTrigger = () => {
        axios.post(`/api/Integrations/Trigger/${this.state.integration.triggerId}/$run`, {}).then((response) => {
            alert({
                type: "alert-info",
                text: response.data,
            });
        });
    };

    render() {
        return (
            <div>
                <div className="form-group row">
                    <label className="col-sm-2 col-form-label my-auto">Trigger ID</label>
                    <div className="col-sm-4 pl-0 my-auto">
                        <small>{this.state.integration.triggerId || "--"}</small>
                    </div>
                    <label className="col-sm-3 col-form-label">Trigger Last Run</label>
                    <div className="col-sm-3 pl-0 my-auto">{this.state.integration.triggerLastRun}</div>
                </div>
                <div className="form-group row">
                    <div className="col-sm-12">
                        {PermissionStore.CheckCurrentUserHasPermission("executeTriggers") && (
                            <div className="d-flex align-items-end flex-column h-100">
                                <div className="mt-auto">
                                    {this.state.integration.triggerEnabled && (
                                        <div>
                                            <button className="btn btn-warning me-1" onClick={this.disableTrigger}>
                                                Disable Trigger
                                            </button>
                                            {/* {(this.state.account || this.state.account.hasRole('Admin')) &&
                                        <button className="btn btn-primary" onClick={this.testTrigger}>Test Trigger</button>
                                    } */}
                                        </div>
                                    )}
                                    {!this.state.integration.triggerEnabled && (
                                        <button className="btn btn-success" onClick={this.enableTrigger}>
                                            Enable Trigger
                                        </button>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}
